// MenuInfoTree.js
import React, { useState } from 'react';
import { styled  } from '@mui/material/styles';
import { Box } from '@mui/system';
import { IconButton } from '@mui/material';
import TopicIcon from '@mui/icons-material/Topic';
import PlayArrowIcon from '@mui/icons-material/PlayArrow';
import { AppMenuUrl, AppStyle, AppWord } from '../../value/AppConst';

const HorizontalBox = styled(Box)({
    display: 'flex', flexWrap: 'wrap'
});
const TopColumn = styled(Box)({
    padding: 5, border: AppStyle.BorderCCC, borderRadius: 5, marginRight: 5, marginBottom: 5,
    '&:last-of-type': {marginRight: 0},
    '&:hover': {border: '1px solid ' + AppStyle.PrimaryRGB}
});
const TopColumnHeader = styled(Box)({
    backgroundColor: AppStyle.PrimaryRGB, color: 'white', borderRadius: 5, textAlign: 'center',
    padding: 10, marginBottom: 5,
});

const RecordBox = styled(Box)({
    display: 'flex', alignItems: 'center', fontSize: '0.82rem', height: 32,
    '&:hover': {backgroundColor: '#f8f8f8'},
});
const MenuTextBox = styled(Box)({
    flexGrow: 1, padding: 5,
});
const ChildBox = styled(Box)({
    paddingLeft: 15,
});
const ToolBox = styled(Box)({
    display: 'flex', alignItems: 'center',
});

const BigMessageBox = styled(Box)({
    display: 'flex', alignItems: 'center', justifyContent: 'center', minHeight: 300,
    fontSize: '3rem', color: '#cdf', fontWeight: 'bold',
});

// Copy all from AppMenuUrl object
// AppHeader에서도 참조.
export const MenuNotImplemented = [
    //AppMenuUrl.Bbs, // 게시판
    //AppMenuUrl.VehBbs, // 배차현황 게시판
    //AppMenuUrl.BackBbs,  // 업데이트 게시판
    //AppMenuUrl.UserBbs, // 사용자 게시판
    //AppMenuUrl.UserInfo, // 사용자 조회
    //AppMenuUrl.AllocInfo, // 승인요청 조회
    // AppMenuUrl.DCInfo, // 출발지 조회
    // AppMenuUrl.ArriveInfo, // 도착지 조회
    // AppMenuUrl.ComInfo, // 출발지 운송사 조회
    // AppMenuUrl.StoreInfoTab, // 점포관리 (for Store) => 점포정보관리.
    // AppMenuUrl.ShippingPlan, // 출고 예정수량 등록 - TPC 타겟 저장은 안쓰는 것.
    // AppMenuUrl.AvailableTruck, // 가용차량 등록
    // AppMenuUrl.TypeTonSet, // 운송사 차종 등록
    //AppMenuUrl.StoreDida, // 점포휴무일 등록
    //AppMenuUrl.StoresShareTruck, // 동적 점포 등록
    // AppMenuUrl.TransPlan, // 운송요청 등록
    //AppMenuUrl.TransPlanDownload, // 운송요청 다운로드
    // AppMenuUrl.VehRegisterCom, // 운송사별 고정차
    // AppMenuUrl.VehRegisterDC, // 센터별 용차
    // AppMenuUrl.Menu, // 메뉴관리
    //AppMenuUrl.VehTypeGroup, // 차종관리
    //AppMenuUrl.CommonCode, // 공통코드관리
    // AppMenuUrl.AutoPlanA, // 상온 자동배차
    AppMenuUrl.AutoBaseF, // 신선 자동배차 기초 정보 - not used
    AppMenuUrl.AutoPlanF, // 신선 자동배차 - not used
    // AppMenuUrl.VehInfo, // 차량등록현황 - 애초에 빈 화면이었으나 간단하게 채워넣음.
    // AppMenuUrl.TSR, // TSR 발행
    // AppMenuUrl.TransPlanState, // 배차현황 (물류센터 사용자용)
    // AppMenuUrl.TransPlanBindState, // 배송상태 현황
    // AppMenuUrl.Store, // 점포관리 - DC to Store (ArrivalToStore.js)
    // AppMenuUrl.BanAndLimit, // 배차금지 및 제한
    // AppMenuUrl.VehTransPos, // 차량관제 리스트 - Next target.
    // AppMenuUrl.VehLocation, // 차량위치 리스트
    // AppMenuUrl.VehRoute, // 차량경로 리스트
    // AppMenuUrl.Temp, // 온도관제 리스트
    //AppMenuUrl.LocationMap, // 차량위치
    //AppMenuUrl.TransPlanReport, // 운송실적 Report
    //AppMenuUrl.OnTimeArriveReport, // 정시도착 Report
    //AppMenuUrl.UnStoreResultReport, // 출고실적 Report
    //AppMenuUrl.TempReport, // 온도관제 Report
    //AppMenuUrl.TSRResultReport, // TSR결과 Report
    //AppMenuUrl.StoreTransReport, // 점포운송 Report
    //AppMenuUrl.ComTransPlanState, // 홈플러스 배차현황
    // AppMenuUrl.ComTransPlan, // 홈플러스 배차등록
    // AppMenuUrl.HpTransPlanReport, // 홈플러스 운송실적 Report
    // AppMenuUrl.HpOnTimeArriveReport, // 홈플러스 정시도착 Report
    // AppMenuUrl.TraRent, // 용차관리
    // AppMenuUrl.TraSMS, // SMS 보내기
    // AppMenuUrl.centerState, // 물류센터 상태전환
    AppMenuUrl.LogHistory, // 로그정보 이력 - No real implementation (empty screen)
    AppMenuUrl.DataBackup, // 데이터 백업 조회 - not used
    AppMenuUrl.TransPlanSync, // 운송요청 동기화 - not used
    //AppMenuUrl.NewWin, // 새창띄우기
    //AppMenuUrl.MenuReload, // 메뉴 다시 읽기
    /* 
    VehBbs: 'TAB_VehBbs', // 배차현황 게시판
    BackBbs: 'TAB_BackBbs', // 업데이트 게시판
    UserBbs: 'TAB_UserBbs', // 사용자 게시판
    UserInfo: 'TAB_UserInfo', // 사용자 조회
    AllocInfo: 'TAB_AllocInfo', // 승인요청 조회
    DCInfo: 'TAB_DCInfo', // 출발지 조회
    ArriveInfo: 'TAB_ArriveInfo', // 도착지 조회
    ComInfo: 'TAB_ComInfo', // 출발지 운송사 조회
    StoreInfoTab: 'TAB_StoreInfoTab', // 점포관리
    ShippingPlan: 'TAB_AutoTab1', // 출고 예정수량 등록
    AvailableTruck: 'TAB_AutoTab2', // 가용차량 등록
    TypeTonSet: 'TAB_AutoTab3', // 운송사 차종 등록
    StoreDida: 'TAB_AutoTab4', // 점포휴무일 등록
    StoresShareTruck: 'TAB_AutoTab5', // 동적 점포 등록
    TransPlan: 'TAB_TransPlan', // 운송요청 등록
    TransPlanDownload: 'TAB_TransPlanDownload', // 운송요청 다운로드
    VehRegisterCom: 'TAB_VehRegisterCom', // 운송사별 고정차
    VehRegisterDC: 'TAB_VehRegisterDC', // 센터별 용차
    Menu: 'NM_Menu', // 메뉴관리
    VehTypeGroup: 'NM_VehTypeGroup', // 차종관리
    CommonCode: 'NM_CommonCode', // 공통코드관리
    AutoPlanA: 'NM_AutoPlanA', // 상온 자동배차
    AutoBaseF: 'NM_AutoBaseF', // 신선 자동배차 기초 정보
    AutoPlanF: 'NM_AutoPlanF', // 신선 자동배차
    VehInfo: 'NM_VehInfo', // 차량등록현황
    TSR: 'NM_TSR', // TSR 발행
    TransPlanState: 'NM_TransPlanState', // 배차현황
    TransPlanBindState: 'NM_TransPlanBindState', // 배송상태 현황
    Store: 'NM_Store', // 점포관리
    BanAndLimit: 'NM_BanAndLimit', // 배차금지 및 제한
    VehTransPos: 'NM_VehTransPos', // 차량관제 리스트
    VehLocation: 'NM_VehLocation', // 차량위치 리스트
    VehRoute: 'NM_VehRoute', // 차량경로 리스트
    Temp: 'NM_Temp', // 온도관제 리스트
    LocationMap: 'LocationMap', // 차량위치지도
    TransPlanReport: 'NM_TransPlanReport', // 운송실적 Report
    OnTimeArriveReport: 'NM_OnTimeArriveReport', // 정시도착 Report
    UnStoreResultReport: 'NM_UnStoreResultReport', // 출고실적 Report
    TempReport: 'NM_TempReport', // 온도관제 Report
    TSRResultReport: 'NM_TSRResultReport', // TSR결과 Report
    StoreTransReport: 'NM_StoreTransReport', // 점포운송 Report
    ComTransPlanState: 'NM_ComTransPlanState', // 홈플러스 배차현황
    ComTransPlan: 'NM_ComTransPlan', // 홈플러스 배차등록
    HpTransPlanReport: 'NM_HpTransPlanReport', // 홈플러스 운송실적 Report
    HpOnTimeArriveReport: 'NM_HpOnTimeArriveReport', // 홈플러스 정시도착 Report
    TraRent: 'NM_TraRent', // 용차관리
    TraSMS: 'NM_TraSMS', // SMS 보내기
    centerState: 'centerState', // 물류센터 상태전환
    LogHistory: 'NM_LogHistory', // 로그정보 이력
    DataBackup: 'NM_DataBackup', // 데이터 백업 조회
    TransPlanSync: 'NM_TransPlanSync', // 운송요청 동기화
    NewWin: 'NewWin', // 새창띄우기
    MenuReload: 'MenuReload', // 메뉴 다시 읽기 */
];

export const MenuHardWorking = [
    // AppMenuUrl.TransPlan, // 운송요청 등록 (TransPlanLaunch.js)
    // AppMenuUrl.TSR, // TSR 발행 (TransPlanTsr.js, TransPlanTsrVo.java+[TransPlanBulkItemsVo.java])
    // AppMenuUrl.Store, // 점포관리 (ArrivalToStore.js)
    // AppMenuUrl.TraSMS, // SMS 보내기 (SmsMessage.js)
    // AppMenuUrl.TransPlanDownload, // 운송요청 다운로드
    // AppMenuUrl.TransPlanReport, // 운송실적 Report
    // AppMenuUrl.OnTimeArriveReport, // 정시도착 Report
    // AppMenuUrl.UnStoreResultReport, // 출고실적 Report
    // AppMenuUrl.TempReport, // 온도관제 Report
    // AppMenuUrl.TSRResultReport, // TSR결과 Report
    // AppMenuUrl.StoreTransReport, // 점포운송 Report
];

/**
 * 메뉴 정보 트리 표시. 컴포넌트의 배치, 스크롤 등은 부모에서 처리.
 * 메뉴 관리 용도.
 * @param {*} param
 */
export default function MenuInfoTree({
    treeData,
    tools, // [{icon, id}]
    onClickTool, // (id)=>{}
    horizontal // if true, top category is horizontal
}) {
    const [menuHover, setMenuHover] = useState(null);

    const onClickTookIcon = (toolId, menu) => {
        setMenuHover(null);
        onClickTool(toolId, menu);
    };

    const renderGroup = (group) => {
        if(group.children.length === 0) return null;

        return(
            <React.Fragment key={group.menuId}>
                <RecordBox>
                    <TopicIcon color={AppStyle.mui.primary}
                        style={{marginRight:3, fontSize:'0.9rem', color:'#7af'}}/>
                    <MenuTextBox style={{fontWeight:'bold'}}>{group.menuName}</MenuTextBox>
                </RecordBox>
                <ChildBox>
                {
                    group.children.map(child=>renderNode(child))
                }
                </ChildBox>
            </React.Fragment>
        )
    };

    const renderNode = (node) => {
        if(node.children) return renderGroup(node);
        return (
            <RecordBox key={node.menuId}
                onMouseEnter={()=>setMenuHover(node.menuId)}
                onMouseLeave={()=>setMenuHover(null)}
            >
                <PlayArrowIcon
                    style={{marginRight:0, fontSize:'0.9rem', color:'#9cf'}}/>
                <MenuTextBox
                    style={{color: MenuHardWorking.includes(node.menuUrl) ? '#f00' : MenuNotImplemented.includes(node.menuUrl) ? '#999' : 'black'}}
                >
                    {node.menuName}
                </MenuTextBox>
                {
                    tools && tools.length && menuHover === node.menuId
                    ?
                    <ToolBox>
                        {tools.map(tool=>(
                            <IconButton key={tool.id}
                                size={AppWord.SMALL}
                                onClick={()=>onClickTookIcon(tool.id, node)}
                                color={tool.color ? tool.color : AppStyle.mui.inherit}
                            >
                                {tool.icon}
                            </IconButton>
                        ))}
                    </ToolBox>
                    : null
                }
            </RecordBox>
        );
    };

    if(treeData.length === 0) {
        return(
            <BigMessageBox>
                잠시 기다려 주세요.
            </BigMessageBox>
        );
    }

    if(horizontal) {
        return(
            <HorizontalBox>
                {
                    treeData.map(node=>(
                        <TopColumn key={node.menuId}>
                            <TopColumnHeader>{node.menuName}</TopColumnHeader>
                            <Box>
                                {
                                    node.children.map(child=>renderNode(child))
                                }
                            </Box>
                        </TopColumn>
                    ))
                }
            </HorizontalBox>
        );
    }

    return(
        <Box>
            {
                treeData.map(node=>renderNode(node))
            }
        </Box>
    );
}
